import React from 'react';
import { Sprite, withPixiApp } from '@inlet/react-pixi';

class Mover extends React.Component {

  state = {
    value: 0,
    defaultAlpha: 0,
    alpha: 0,
    defaultScale: 0,
    scale: 0
  }
  counter = 0
  counter2 = 0

  componentDidMount() {
    this.setState({
      value: this.props.from,
      defaultAlpha: this.props.alpha,
      alpha: this.props.alpha,
      defaultScale: this.props.scale,
      scale: this.props.scale,
      singleScaleValue: this.props.scale[0]
    })
    this.props.app.ticker.add(this.tick)
  }

  componentWillUnmount() {
    this.props.app.ticker.remove(this.tick)
  }

  tick = (delta) => {

    let newAlpha = 0;
    this.counter += 0.0025 * delta;
    let value = this.counter;

    const { ease, speed } = this.props

    this.counter2 += speed * delta
    let value2 = 0;

    if( this.props.active ) {
      newAlpha = (this.state.alpha >= 1) ? 1 : this.state.alpha + 0.04;
      value2 = 4 + (6-4) / 2 + ease(this.counter2) * (4 - 6) / 2
    } else {
      newAlpha = (this.state.alpha <= this.state.defaultAlpha) ? this.state.defaultAlpha : this.state.alpha - 0.02;
      value2 = ( this.state.scale[0] > 4 ) ? this.state.scale[0] - 0.04 : 4 ;
    }

    this.setState({
      value,
      alpha: newAlpha,
      scale: [value2,value2]
    })

  }

  render() {
    return this.props.children({value: this.state.value, i: this.counter, alpha: this.state.alpha, scale: this.state.scale });
  }
}

const MoverWithApp = withPixiApp(Mover)

export class LightContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      sw: 0,
      sh: 0,
      ready: false,
      speed: this.props.lightBurstData.speed / 200,
      scale: this.props.lightBurstData.scale,
      alpha: this.props.lightBurstData.alpha,
      anchor: this.props.lightBurstData.anchor
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if ( prevState.sw !== nextProps.screen.sw ||
         prevState.sh !== nextProps.screen.sh ||
         prevState.alpha !== nextProps.lightBurstData.alpha ||
         prevState.speed !== nextProps.lightBurstData.speed ) {
      return {
        sw: nextProps.screen.sw,
        sh: nextProps.screen.sh,
        alpha: nextProps.lightBurstData.alpha,
        speed: nextProps.lightBurstData.speed
      };
    }
    return null;
  }

  shouldComponentUpdate(nextProps, nextState) {
    if ( this.state !== nextState ) {
      return true
    } else {
      return false
    }
  }

  activate = () => {
    this.setState({
      active: true
    })
  }

  deActivate = () => {
    this.setState({
      active: false
    })
  }

  render() {
    return (
      <MoverWithApp scale={this.state.scale} alpha={this.props.lightBurstData.alpha} active={this.state.active} from={ 1 } to={ 6 } ease={ Math.sin } speed={ this.state.speed }>
        {({ value, i, alpha, scale }) => {
          return (
          <Sprite texture={this.props.texture}
                  scale={scale}
                  alpha={alpha}
                  anchor={this.state.anchor}
                  rotation={value}
                  x={this.state.sw * 0.5}
                  y={this.state.sh * 0.40} />
        )}}
      </MoverWithApp>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Layers/Light.js